export default {
  isPreload(state) {
    return state.preload;
  },

  getPopupValue(state) {
    return state.currentPopup.value;
  },

  getDangerPopup(state) {
    return state.dangerPopup;
  },
};
